import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import _ from 'lodash';
import { CartItem } from '../../../stores/cart/types';
import FlyoutMenu from '../FlyoutMenu';
import Header from '../Header';
import CartList from './CartList';
import Footer from './Footer';

interface Props {
  items: CartItem[];
  deleteProduct: (product: SearchProduct) => void;
  isOpen: boolean;
  toggle: () => void;
}

export default function DrawerCart(props: Props) {
  const totalPrice = props.items.reduce(
    (a, b) =>
      a + ((b.product.discountedPrice || b.product.price) * b.quantity || 0),
    0,
  );

  if (!props.isOpen) {
    return null;
  }

  return (
    <div className="relative sm:block contents">
      <FlyoutMenu
        isOpen={props.isOpen}
        onCloseMenu={props.toggle}
        header={<Header onCloseMenu={props.toggle} />}
        footer={
          <Footer
            closeMenu={props.toggle}
            totalPrice={totalPrice}
            isCartEmpty={_.isEmpty(props.items)}
          />
        }
      >
        <div className="sm:max-h-[65vh] sm:w-96 p-6 flex-1 overflow-auto sm:rounded-b-xl bg-white">
          <CartList items={props.items} />
        </div>
      </FlyoutMenu>
    </div>
  );
}
